<template>
    <x-page title="Bulk Update Pengunjung">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>

        <form id="bulk-update-form" @submit.prevent="handleSubmit" class="form-horizontal">
            <fieldset :disabled="isLoading">

                <x-form-group label="Status"
                    :error="getError('status')"
                    :is-required="true"
                    help-text="Ubah ke status yang dipilih">
                    <x-member-status-dropdown v-model="fields.status" :allowed-statuses="['Jemaat Aktif']" />
                </x-form-group>

                <x-form-group label="Pengunjung"
                    :error="getError('member_ids')"
                    :is-required="false"
                    help-text="Pengunjung yang ingin di-update">
                    <x-table :headers="[
                        '',
                        'Pengunjung',
                        'Status',
                    ]">
                        <tr v-for="(member, index) in members" :key="index">
                            <td>
                                <x-delete-item-button @click="deleteMember(index)" />
                            </td>
                            <td>
                                <x-form-group :error="getError(`members.${index}`)">
                                    <x-ajax-dropdown url="/api/visitors"
                                        :blacklist="fields.member_ids"
                                        label="name"
                                        :value="member"
                                        @input="value => setMember(index, value)"
                                        class="form-control"
                                        :query="{ without_global_scopes: 1 }" />
                                </x-form-group>
                            </td>
                            <td>
                                <x-form-group>
                                    <input type="text"
                                        class="form-control"
                                        :value="member.status"
                                        disabled />
                                </x-form-group>
                            </td>
                        </tr>
                        <template #footer="{ colspan }">
                            <tr>
                                <td :colspan="colspan" class="text-center">
                                    <x-add-item-button @click="addMember" />
                                </td>
                            </tr>
                        </template>
                    </x-table>
                </x-form-group>

            </fieldset>
        </form>

        <template #footer>
            <x-submit-button form="bulk-update-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XAddItemButton from '../../components/XAddItemButton.vue'
import XAjaxDropdown from '../../components/XAjaxDropdown.vue'
import XBackButton from '../../components/XBackButton.vue'
import XDeleteItemButton from '../../components/XDeleteItemButton.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import XMemberStatusDropdown from '../../components/XMemberStatusDropdown.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import XTable from '../../components/XTable.vue'
import { defaultMemberStatus, handleValidationXhrError } from '../../helpers'
import FormErrorMixin from '../../mixins/FormErrorMixin'
export default {
    components: {
        XPage,
        XBackButton,
        XFormGroup,
        XMemberStatusDropdown,
        XSubmitButton,
        XTable,
        XAddItemButton,
        XAjaxDropdown,
        XDeleteItemButton,
    },
    data() {
        return {
            fields: {
                member_ids: [],
                status: defaultMemberStatus(),
            },
            isLoading: false,
            members: [],
        }
    },
    methods: {
        addMember() {
            this.members.push({})
        },
        deleteMember(target) {
            this.members = this.members.filter((member, index) => index != target)
        },
        handleSubmit() {
            this.isLoading = true
            const request = axios.put(`/api/visitors`, this.fields)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `Bulk update berhasil!`,
                    })
                    this.$router.back()
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
            }).finally(() => {
                this.isLoading = false
            })
        },
        setMember(index, value) {
            this.$set(this.members, index, value)
        },
    },
    mixins: [
        FormErrorMixin,
    ],
    watch: {
        members: {
            handler(members) {
                this.fields.member_ids = members.map(member => member.id)
            },
            deep: true,
        },
    },
}
</script>
